import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  type: ToastType;
  title?: string;
  message: string;
  duration: number;
  leaving?: boolean;
}

interface ToastOptions {
  title?: string;
  duration?: number; // ms
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;
  private readonly MAX_VISIBLE = 4;

  readonly toasts = signal<Toast[]>([]);

  show(type: ToastType, message: string, options: ToastOptions = {}) {
    const toast: Toast = {
      id: ++this.counter,
      type,
      message,
      title: options.title,
      duration: options.duration ?? (type === 'error' ? 6000 : 4000),
    };
    this.toasts.update(list => [...list, toast].slice(-this.MAX_VISIBLE));
  }

  success = (message: string, options?: ToastOptions) => this.show('success', message, options);
  error = (message: string, options?: ToastOptions) => this.show('error', message, options);
  warning = (message: string, options?: ToastOptions) => this.show('warning', message, options);
  info = (message: string, options?: ToastOptions) => this.show('info', message, options);

  dismiss(id: number) {
    this.toasts.update(list => list.map(t => (t.id === id ? { ...t, leaving: true } : t)));
    setTimeout(() => this.toasts.update(list => list.filter(t => t.id !== id)), 220);
  }
}